import {
  ByIdPayload,
  FailByIdPayload,
  NormalizedSingle,
  OperationReducerTypes,
  PayloadAction,
  SuccessByIdPayload,
  uniqueActionType
} from '@industi/ngx-common';

export const DictionaryBrandLoadDetailsActionTypes: OperationReducerTypes = {
  request: uniqueActionType('[dictionary/brand] Load details'),
  requestFail: uniqueActionType('[dictionary/brand] Load details fail'),
  requestSuccess: uniqueActionType('[dictionary/brand] Load details success'),
  requestClearErrors: uniqueActionType('[dictionary/brand] Load details clear errors'),
  requestClear: uniqueActionType('[dictionary/brand] Load details clear')
};

export class DictionaryBrandLoadDetailsAction implements PayloadAction {
  readonly type = DictionaryBrandLoadDetailsActionTypes.request;

  constructor(public payload: ByIdPayload) {
  }
}

export class DictionaryBrandLoadDetailsFailAction implements PayloadAction {
  readonly type = DictionaryBrandLoadDetailsActionTypes.requestFail;

  constructor(public payload: FailByIdPayload) {
  }
}

export class DictionaryBrandLoadDetailsSuccessAction implements PayloadAction {
  readonly type = DictionaryBrandLoadDetailsActionTypes.requestSuccess;

  constructor(public payload: SuccessByIdPayload<NormalizedSingle>) {
  }
}

export class DictionaryBrandLoadDetailsClearAction implements PayloadAction {
  readonly type = DictionaryBrandLoadDetailsActionTypes.requestClear;

  constructor(public payload: ByIdPayload) {
  }
}

export class DictionaryBrandLoadDetailsClearErrorsAction implements PayloadAction {
  readonly type = DictionaryBrandLoadDetailsActionTypes.requestClearErrors;

  constructor(public payload: ByIdPayload) {
  }
}
